import { Injectable } from '@angular/core';
import { CatalogMeta } from '../models/catalog.model';

@Injectable({
	providedIn: 'root'
})
export class CatalogMetaService {
	catalogMeta: Partial<CatalogMeta>;
}
